export const PRICING_PAGE_UUID = 'a7aa9780-213f-4e7b-b0a8-664945d8fd5d'

export const PRICING_ACTION_UUID = '6ef6bb65-c8e3-4b48-bd93-1f1157e82d10'
